import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { getMappedNationalities } from "@rentiohq/shared-frontend/dist/utils/location/location.utils";
import { getAddressComponentFields } from "@rentiohq/web-shared-next/dist/utils/address";
import {
  ERentioFormField,
  IFormikProps,
  IFormikValues,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField } from "./schema.profileExtra.types";

export const uiSchema = (): IUiSchema => {
  return {
    stepTitle: getLocalizedText("task.information.section_header"),
    heading: getLocalizedText("task.information.section_header"),
    fields: [
      {
        fieldKey: EField.Nationality,
        title: getLocalizedText("system.nationality"),
        uiComponent: ERentioFormField.Select,
        optional: true,
        componentProps: {
          options: getMappedNationalities(),
        },
      },
      {
        fieldKey: "heading",
        uiComponent: ERentioFormField.Heading,
        componentProps: {
          title: getLocalizedText("system.birth_details"),
        },
      },
      {
        fieldKey: EField.DateOfBirth,
        uiComponent: ERentioFormField.Date,
        title: getLocalizedText("system.date_of_birth"),
        optional: true,
        componentProps: {
          autoFocus: true,
          disablePast: false,
        },
      },
      {
        fieldKey: EField.PlaceOfBirth,
        uiComponent: ERentioFormField.AddressAutoComplete,
        title: getLocalizedText("system.place_of_birth"),
        optional: true,
        onChange: (params, formikProps: IFormikProps<IFormikValues>) => {
          const { address } = params as any;
          if (address) {
            formikProps.setFieldValue(EField.PlaceOfBirth, address?.city);
            formikProps.setFieldValue("countryOfBirth", address?.country);
          }
        },
        componentProps: {
          lookupTypes: ["(cities)"],
        },
      },
      ...getAddressComponentFields({
        addressFieldKey: EField.PlaceOfBirth,
        lookupTypes: ["(cities)"],
        overridedSpans: {
          city: [12],
          country: [12],
        },
        overridedFields: {
          city: EField.PlaceOfBirth,
          country: "countryOfBirth",
        },
      }),
    ],
  };
};
